import React from "react";
import * as Modal from '../../common/components/modal/modalDialog';
import Dialog from '@material-ui/core/Dialog';
import { createMuiTheme, MuiThemeProvider, Button, FormControl, InputLabel, Select, MenuItem, TextField } from '@material-ui/core';
import blue from '@material-ui/core/colors/blue';
import Translate from "../../common/functions/translate";
import { OfferFilterSettingsModel } from "../../models/offer/offerFilterSettingsModel";
import { DropdownModel } from "../../models/dropdownModel";
import * as HelperFunctions from '../../common/functions/helperFunctions';
import { OfferStatus, TimePeriod } from "../../common/enums";
import { DatePicker } from "@material-ui/pickers";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface IProps {
    isVisible: boolean;
    cancelClick: any;
    filterClick: any;
    clearFilters: any;
    filterSettings: OfferFilterSettingsModel;
}

interface IState {
    filterSettings: OfferFilterSettingsModel,
    statuses: Array<DropdownModel>;
    timePeriods: Array<DropdownModel>;
}

const theme = createMuiTheme({
    overrides: {
        MuiFormControl: {
            marginNormal: {
                marginTop: 5,
                marginBottom: 0,
                width: '100%'
            },
            root: {
                width: '100%'
            }
        },
        MuiFormControlLabel: {
            root: {
                marginLeft: '0px'
            }
        },
        MuiDialog: {
            paper: {
                margin: 0,
                maxWidth: '90% !important'
            },
            paperFullWidth: {
                width: '40%'
            }
        },
    },
    palette: {
        primary: blue
    }
})

class OfferFilter extends React.Component<IProps, IState> {

    constructor(props) {
        super(props)

        this.state = {
            filterSettings: this.props.filterSettings,
            statuses: new Array<DropdownModel>(0),
            timePeriods: new Array<DropdownModel>(0),
        }
    }

    componentWillReceiveProps() {
        this.setState({
            filterSettings: this.props.filterSettings
        });
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyPressed, false);

        const timePeriods: Array<DropdownModel> = [{ label: Translate('Select'), value: 0 },];
        const statuses: Array<DropdownModel> = [{ label: Translate('Select'), value: 0 }];

        this.setState({
            timePeriods: timePeriods.concat(HelperFunctions.enumToDropdownArray(TimePeriod, true)),
            statuses: statuses.concat(HelperFunctions.enumToDropdownArray(OfferStatus, true)),
        });
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyPressed, false);
    }

    handleKeyPressed = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.handleFilterClick();
        }
    }

    handleChange = (key, value) => {
        if (key === 'timePeriodId' && value === 0) {
            value = undefined;
        }

        const filterSettings: OfferFilterSettingsModel = { ...this.state.filterSettings };

        if (key === 'timePeriodId' && value) {
            let startDate = new Date();
            let endDate = new Date();
            let monthsAgo = this.getMonthsAgoValue(value);

            startDate.setMonth(startDate.getMonth() - monthsAgo);

            filterSettings.startDate = HelperFunctions.fomatDateAsString(startDate);
            filterSettings.endDate = HelperFunctions.fomatDateAsString(endDate);
        }

        filterSettings[key] = value;
        this.setState({ filterSettings: { ...filterSettings } });
    };

    getMonthsAgoValue = (value) => {
        switch (value) {
            case 1: {
                return 1;
            }
            case 2: {
                return 3;
            }
            case 3: {
                return 12;
            }
            default: {
                return 0;
            }
        }
    }

    handleFilterClick = () => {
        const filterSettings = { ...this.state.filterSettings };
        this.props.filterClick(filterSettings);
    }

    render() {
        const { filterSettings } = this.state;

        return (
            <MuiThemeProvider theme={theme}>
                <Dialog
                    open={this.props.isVisible}
                    onClose={() => this.props.cancelClick()}
                    fullWidth
                    disableBackdropClick={true}>
                    <Modal.DialogTitle id="customized-dialog-title" onClose={() => this.props.cancelClick()}>{Translate('Filters')}</Modal.DialogTitle>
                    <Modal.DialogContent>
                        <FormControl>
                            <InputLabel htmlFor="status-label">{Translate('Status')}</InputLabel>
                            <Select
                                name="statusId"
                                value={filterSettings.statusId ? filterSettings.statusId : ''}
                                onChange={(e) => this.handleChange('statusId', e.target.value)}
                                style={{ marginRight: 10 }}
                                inputProps={{
                                    id: 'status-label'
                                }}
                            >
                                {
                                    this.state.statuses.map(m => <MenuItem key={m.value + 'status'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                                }
                            </Select>
                        </FormControl>
                        <FormControl style={{ marginTop: 10 }}>
                            <TextField
                                name="number"
                                type="text"
                                style={{ marginRight: 10 }}
                                label={Translate("Number")}
                                onChange={(e) => this.handleChange('number', e.target['value'])}
                                value={filterSettings.number ? filterSettings.number : ''}
                            />
                        </FormControl>
                        <FormControl style={{ marginTop: 10 }}>
                            <TextField
                                name="client"
                                type="text"
                                style={{ marginRight: 10 }}
                                label={Translate("Client")}
                                onChange={(e) => this.handleChange('client', e.target['value'])}
                                value={filterSettings.client ? filterSettings.client : ''}
                            />
                        </FormControl>
                        <FormControl style={{ marginTop: 40 }}>
                            <InputLabel htmlFor="timePeriod-label">{Translate('Period')}</InputLabel>
                            <Select
                                name="timePeriodId"
                                value={filterSettings.timePeriodId ? this.state.filterSettings.timePeriodId : ''}
                                onChange={(e) => this.handleChange('timePeriodId', e.target.value)}
                                style={{ marginRight: 10 }}
                                inputProps={{
                                    id: 'timePeriod-label'
                                }}
                            >
                                {
                                    this.state.timePeriods.map(m => <MenuItem key={m.value + 'timePeriod'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                                }
                            </Select>
                        </FormControl>

                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', marginTop: 20 }}>

                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', width: "50%" }}>
                                <div>
                                    <InputLabel htmlFor="fromDate">{Translate('From date')}</InputLabel>
                                    <DatePicker
                                        name="fromDate"
                                        emptyLabel={Translate('From')}
                                        format={Translate('DateFormatUS')}
                                        value={filterSettings.startDate ? new Date(filterSettings.startDate) : null}
                                        onChange={(e) => this.handleChange("startDate", e)}
                                    />
                                </div>
                                <div onClick={() => this.handleChange("startDate", undefined)} style={{ padding: 5, cursor: "pointer" }}>
                                    <FontAwesomeIcon icon={faTimes} style={{ color: '#808080', fontSize: '1.1em', margin: '0 2px' }} />
                                </div>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', width: "50%", marginLeft: "70px" }}>
                                <div>
                                    <InputLabel htmlFor="toDate">{Translate('To date')}</InputLabel>
                                    <DatePicker
                                        name="toDate"
                                        emptyLabel={Translate('To')}
                                        format={Translate('DateFormatUS')}
                                        value={filterSettings.endDate ? new Date(filterSettings.endDate) : null}
                                        onChange={(e) => this.handleChange("endDate", e)}
                                    />
                                </div>
                                <div onClick={() => this.handleChange("endDate", undefined)} style={{ padding: 5, cursor: "pointer" }}>
                                    <FontAwesomeIcon icon={faTimes} style={{ color: '#808080', fontSize: '1.1em', margin: '0 2px' }} />
                                </div>
                            </div>

                        </div>
                    </Modal.DialogContent>
                    <Modal.DialogActions>
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <div>
                                <Button color='secondary' variant="contained" onClick={() => this.props.clearFilters()}>
                                    {Translate("Clear")}
                                </Button>
                            </div>
                            <div>
                                <Button onClick={() => this.props.cancelClick()} variant="contained" style={{ marginRight: 10 }}>
                                    {Translate("Cancel")}
                                </Button>
                                <Button color="primary" variant="contained" onClick={this.handleFilterClick}>
                                    {Translate('Filter')}
                                </Button>
                            </div>
                        </div>
                    </Modal.DialogActions>
                </Dialog>
            </MuiThemeProvider>
        )
    }

}

export default OfferFilter;